import { Component, OnInit, ChangeDetectionStrategy, Input, HostListener, ElementRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { QueueService } from '../../services/queue.service';
import { PrettyJsonPipe } from '../../pipes/pretty_json.pipe';
import { NgIf, AsyncPipe } from '@angular/common';
import { DxSelectBoxComponent, DxSelectBoxModule } from 'devextreme-angular';

@Component({
    selector: 'app-shell-pretty-json-viewer',
    templateUrl: './pretty-json-viewer.component.html',
    styleUrls: ['./pretty-json-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, AsyncPipe, PrettyJsonPipe, DxSelectBoxModule]
})
export class PrettyJsonViewerComponent implements OnInit {
	public _inputJson: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	@Input()
	set json(value: string) {
		this._inputJson.next(value);
	}

	showDialog = new Subject<boolean>();
	showDialog$ = this.showDialog.asObservable();

	sessionHistory$: Observable<any> = new Observable<any>();

	constructor(private eRef: ElementRef, private queueService: QueueService) {}

	ngOnInit(): void {}

	onSessionId(sessionId: string) {
		this.sessionHistory$ = this.queueService.GetInstanceHistorySessionId(sessionId);
	}

	selectInstanceHistory(e: any) {
		this._inputJson.next(e.value.json);
	}

	toggleModal(showModal: boolean) {
		this.showDialog.next(showModal);
	}

	close() {
		this.showDialog.next(false);
	}

	copyToClipboard(): void {
		let listener = (e: ClipboardEvent) => {
			e.clipboardData.setData('text/plain', this._inputJson.value);
			e.preventDefault();
		};

		document.addEventListener('copy', listener);
		document.execCommand('copy');
		document.removeEventListener('copy', listener);
	}
}
